/**

 *********	*******		*******		********	**			 **		  ***	 	*******		**	 **
 **			**	 **		**	 **		**			 **	   *    **		 ** **   	**	 **		**** **
 *******	**	 **		*******		********	  **  ***  **		*******  	*******		** ****
 **			**	 **		** *		**			   **** ****	   **	  ** 	** *		**	***
 **			*******		**  **		********		**   **		  **	   **	**  **		**	 **

 * ForeWarn  Licensing and / or usage Terms and Conditions  *******
 * ForeWarn. The NextGen Insights Solution Platform
 * Copyright © 2021 COMPEGENCE. All Rights Reserved
 * ForeWarn is a product of COMPEGENCE.
 * To be used only with a valid license from COMPEGENCE
 * www.compegence.com  info@compegence.com
 **/

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import axios from 'axios'
import VueSelect from 'vue-select'
import vSelect from 'vue-select'
import JsonCSV from 'vue-json-csv'
import JsonExcel from 'vue-json-excel'
import App from './App.vue'
import router from './router'
import store from './store'
import { extractApiErrorMessage } from './common/sqlDataSqlAlias'
import Hammer from './hammer'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-context/dist/css/vue-context.css'
import '@fortawesome/fontawesome-free/css/all.css'

import VueJsonToCsv from 'vue-json-to-csv'
import LoadScript from 'vue-plugin-load-script';
import * as VeeValidate from "vee-validate";


import CommonFn from '@/common'

// ⬇️ NEW: import the debug logger
import { logDebugEvent } from './debugLogger'
import {VueReCaptcha} from "vue-recaptcha-v3";

window.router = router;

Vue.use(Hammer);
Vue.use(VueJsonToCsv);
Vue.use(LoadScript);
Vue.use(VeeValidate);
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.prototype.$commonFn = CommonFn
Vue.use(Chartkick.use(Chart))
Vue.use(require('vue-cookies'))
Vue.component('v-select', VueSelect.VueSelect)
Vue.component('v-select', vSelect)
Vue.component('downloadCsv', JsonCSV)
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueReCaptcha, {
    siteKey: '6Lfsx-ksAAAAAMCQWtnzLIgDpONSxyPuuYalquzs',
    loaderOptions: {
        autoHideBadge: true
    }
})
axios.defaults.baseURL = process.env.VUE_APP_API

Vue.prototype.$logClick = function (payload = {}) {
    const state = store.state;

    logDebugEvent({
        type: 'ui-click',
        userId: state.user.userId,
        username: state.user.username,

        route: payload.route,
        menuId: payload.menuId ,
        submenuId: payload.submenuId,

        element: payload.element,   // e.g. 'region-listbox'
        action: payload.action || 'click',
        extra: payload.extra || null
    });
};


function getRouteContext() {
    const currentRoute = router.currentRoute || {};
    const params = currentRoute.params || {};
    return {
        routePath: currentRoute.fullPath,
        menuId: params.menuId,
        submenuId: params.submenuId
    };
}



// Install Prompt
// let deferredPrompt;
// const installButton = document.getElementById('install');
//
// // This event listener should be within a script tag or linked JS file
// window.addEventListener('beforeinstallprompt', (e) => {
//   e.preventDefault(); // Prevent the default browser prompt
//   deferredPrompt = e;
//   console.log("before install prompt event fired"); // Changed log for clarity
//   installButton.hidden = false; // Show your custom install button
// });
//
// installButton.addEventListener('click', async () => {
//   if (!deferredPrompt) {
//     console.log("deferredPrompt is null, install prompt not available.");
//     return;
//   }
//   deferredPrompt.prompt(); // Trigger the browser's native install prompt
//   const { outcome } = await deferredPrompt.userChoice; // Wait for user's decision
//   console.log(`User response to install prompt: ${outcome}`);
//   deferredPrompt = null; // Reset deferredPrompt
//   installButton.hidden = true; // Hide your custom button after interaction
// });

// IMPORTANT: You also need a Service Worker!
// Example of a basic Service Worker registration (add this to main.js or a separate SW file)
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js') // Path to your service worker file
//         .then(registration => {
//           console.log('Service Worker registered:', registration);
//         })
//         .catch(error => {
//           console.error('Service Worker registration failed:', error);
//         });
//   });
// }


store.dispatch('checkUserLogin')
  .then(() => {

    new Vue({
      el: '#app',
      router,
      store,
      components: {App},
      template: '<App/>'
    })
  }, () => {

    new Vue({
      el: '#app',
      router,
      store,
      components: {App},
      template: '<App/>'
    })
  })

axios.interceptors.request.use(function (config) {
  // console.log("config",config);
  // Do something before request is sent
  //loading(true)
  //   console.log("config",config)
  if (!store.state.isLoggedIn && config.url.indexOf('/api') > -1) {
    return Promise.reject(Error('not logged In'))
  }
  if(config.url!=='/api/audit-log' &&  !config.url.includes('/api/exportStatus')) {
    store.dispatch('ajaxStart')
  }

    // 🔍 DEBUG LOGGING
    try {
        if (
            config.url &&
            config.url.indexOf('/api') > -1 &&
            !config.url.includes('/api/debug-log') // avoid recursion
        ) {
            const state = store.state;
            const routeCtx = getRouteContext();   // 👈 here we take menuId/submenuId from router

            logDebugEvent({
                type: 'api-call',
                userId: state.user.userId,
                username: state.user.username,
                sessionId: state.sessionId,

                route: routeCtx.routePath,
                menuId: routeCtx.menuId,
                submenuId: routeCtx.submenuId,

                apiPath: config.url,
                apiMethod: config.method,
                params: config.params,
                body: config.data
            });
        }
    } catch (e) {
        console.warn('failed to send debug log', e);
    }

  return config
}, function (error) {
  // Do something with request error
  // loading(false)
  store.dispatch('ajaxComplete')
  return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
  //success will always have 2xx status codes
  // console.log("response",response);
  if(response.config.url!=='/api/audit-log' &&  !response.config.url.includes('/api/exportStatus')) {
    store.dispatch('ajaxComplete')
  }
  return response
}, (error) => {
    //you have to check for status code
    store.dispatch('ajaxComplete')
    console.error('error in interceptor response', error)
    const cfg = error.config || {}
    const skipGlobalDataErrorModal = cfg.skipGlobalDataErrorModal === true
    if (error.message === 'Network Error') {
        //show the server is Down
        // console.log('server is down')
        store.commit('serverDown')
    } else if (error.response && error.response.status === 500) {
        //data error
        if (!skipGlobalDataErrorModal) {
          store.commit('serverError')
        }
        return Promise.reject(error)
    } else if (error.response && error.response.status === 401) {
        console.error('AuthToken Expired, lets logout')
        //this means login is needed
        store.commit('loggedOut')
        store.commit('authError')
        router.push('/login')
        return Promise.reject(error)
    } else if (error.response && error.response.status === 400){
        console.log("backend error")
        if(error.config.url!=='/auth/login' && !skipGlobalDataErrorModal) {
            const url = (error.config.url || '').replace(/\?.*$/, '')
            const isFetchDataOnly = url === '/api/fetchData'
            if (isFetchDataOnly) {
                const message = extractApiErrorMessage(
                  error,
                  "Unable to load preview data. Please review your SQL or contact the data team."
                )
                store.commit('backendError', { show: true, message })
            } else {
                store.commit('backendError', true)
            }
        }
        return Promise.reject(error)
    }
  return Promise.reject(error)
})

